import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { ReactNode } from "react";

import Icon from "common/components/Icon";

import styles from "../../styles/ConditionCheck.module.less";

type ConditionCheckProps = {
  isMet: boolean;
  children: ReactNode;
};

const ConditionCheck = ({ isMet, children }: ConditionCheckProps) => {
  return (
    <div className={styles.container}>
      <Icon icon={faCheck} className={`${styles.check} ${isMet ? styles.active : ""}`} />
      {children}
    </div>
  );
};

export default ConditionCheck;
